module.exports = __webpack_public_path__ + "img/insajder-intelligence-shoptok.a93096db.svg";